angular.module('picmonic-common').directive('easyLink', function () {
  return {
    restrict: 'E',
    replace: true,
    template:
      '<div class="easy-link m-b-2">\n' +
      '        <div>' +
      '            <form name="easyLinkForm">' +
      '                <input type="text" mask="(999) 999-9999" clean="true" ng-model="phone" class="pls-input pls-input--light pls-btn--gradient-blue-small m-r-2" placeholder="Phone number" style="max-width: 264px;" />\n' +
      '                <a class="pls-btn pls-btn--gradient-blue" ng-click="sendEasyLink()" ng-disabled="loading"><span ng-show="!loading">Send Easy Link</span><span ng-show="loading"><pls-loading-icon></pls-loading-icon></span></a>\n' +
      '            </form>' +
      '        </div>' +
      '        <div class="m-t-2 text-center" ng-show="message || error">' +
      '            <div ng-show="error" class="pls-mugatu">{{error}}</div>' +
      '            <div ng-show="messageTitle"><strong>{{messageTitle}}</strong></div>' +
      '            <div ng-show="message">{{message}}</div>' +
      '        </div>' +
      '    </div>',
    scope: {
      onSuccess: '&',
    },
    controller: [
      '$scope',
      'EasyLinkResource',
      function ($scope, EasyLinkResource) {
        $scope.phone = '';
        $scope.sendEasyLink = function () {
          if ($scope.loading) {
            return;
          }

          if ($scope.easyLinkForm.$pristine || !$scope.easyLinkForm.$valid) {
            $scope.error = 'Please enter a valid phone number.';
            return;
          }

          $scope.error = '';
          $scope.messageTitle = '';
          $scope.message = '';
          $scope.loading = true;

          EasyLinkResource.save(
            { phone: $scope.phone },
            function () {
              $scope.messageTitle = 'Success!';
              $scope.message = "We've sent an SMS to your phone. Click the link to download the Picmonic app.";
              $scope.loading = false;
              if ($scope.onSuccess) {
                $scope.onSuccess();
              }
            },
            function (error) {
              $scope.error =
                error.data && error.data.message
                  ? error.data.message
                  : 'There was an error sending your link. Double check your phone number and try again.';
              $scope.loading = false;
            }
          );
        };
      },
    ],
  };
});
